export const colors = {
    en: {
        red: 'Red',
        blue: 'Blue',
        green: 'Green',
        mint: 'Mint',
        yellow: 'Yellow',
        purple: 'Purple',
    },
    ru: {
        red: 'Красный',
        blue: 'Синий',
        green: 'Зеленый',
        mint: 'Мятный',
        yellow: 'Желтый',
        purple: 'Фиолетовый',
    }
};
